<template>
  <div class="install">
    <div class="install-title">汇智投趋势分析系统安装指南</div>

    <div class="install-header">
      <div class="header-1 header-0">01</div>
      <div class="header-1" style="color: #cccccc">/03</div>
      <div class="header-2">下载安装包</div>
    </div>

    <div class="install-first">
      <div class="title">1、进入官网，点击右上角的头像，进入会员中心</div>
      <div class="title">
        2、点击左侧我的订单，点已支付，找到自己的支付记录。
      </div>
      <div class="title">3、点软件下载：汇智投趋势分析系统，下载安装包。</div>
      <div class="img0">
        <img src="../assets/common/01.png" alt="" />
      </div>
    </div>

    <div class="install-header">
      <div class="header-1 header-0">02</div>
      <div class="header-1" style="color: #cccccc">/03</div>
      <div class="header-2">
        安装汇智投趋势分析系统 (<span style="color: #e53333"
          >首次安装需要进行此操作</span
        >)
      </div>
    </div>

    <div class="install-first">
      <div class="title">
        1、解压缩下载后的文件“汇智投趋势分析系统.zip”后，双击“汇智投Setup.exe”开始安装。
      </div>
      <div class="img0">
        <img src="../assets/common/2-1.png" alt="" />
      </div>

      <div class="title">2、安装到交易平台</div>
      <div class="img1">
        <img src="../assets/common/2-2.png" alt="" />
        <img src="../assets/common/2-3.png" alt="" />
        <img src="../assets/common/2-4.png" alt="" />
      </div>

      <div class="title">3、填写认证信息</div>
      <div class="img0">
        <img src="../assets/common/2-5.png" alt="" />
      </div>

      <div class="text">
        商品编码：会员中心 --- 我的订单---已支付中对应的商品编码
      </div>
      <div class="text">产品序列号：会员中心，已支付记录中对应的序列号。</div>
      <div class="img0">
        <img src="../assets/common/2-6.png" alt="" />
      </div>

      <div class="title">
        4、列出电脑中所有的MetaTrader交易平台，点击选择列表中需要安装趋势分析系统的平台。（支持同时安装多个MT5交易平台）
        注：如列表中未能显示对应交易平台，可通过把把平台数据文件夹路径粘贴到最下方的数据文件夹路径进行指定安装。
      </div>

      <div class="img0">
        <img src="../assets/common/2-7.png" alt="" />
      </div>

      <div class="title">5、逐步安装到交易平台</div>

      <div class="img0">
        <img src="../assets/common/2-8.png" alt="" />
      </div>
    </div>

    <div class="install-header">
      <div class="header-1 header-0">03</div>
      <div class="header-1" style="color: #cccccc">/03</div>
      <div class="header-2">开始使用</div>
    </div>

    <div class="install-first">
      <div class="title">
        1、运行已安装汇智投趋势分析系统的MT5交易软件，点击“工具-选项”菜单，在“EA交易”设置中勾选下图红框选项。
      </div>
      <div class="img0">
        <img src="../assets/common/3-1.png" alt="" />
      </div>

      <div class="title">
        2、在导航窗口内，鼠标右键分别选择“指标”、“EA交易”，然后分别单击弹出窗口的“刷新
      </div>
      <div class="img0">
        <img src="../assets/common/3-2.png" alt="" />
      </div>

      <div class="title">
        3、打开任意货币窗口，点击“图表 - 模板 -
        载入模板”菜单，选择“汇智投趋势分析系统模板”,然后单击打开按钮
      </div>
      <div class="img0">
        <img src="../assets/common/3-3.png" alt="" />
      </div>

      <div class="title">4、成功载入模板后，使用界面就如下图</div>
      <div class="img0">
        <img src="../assets/common/3-4.png" alt="" />
      </div>
    </div>

  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
};
</script>

<style lang="less" scoped>
.install {
  margin: 60px 10px;
  text-align: left;
  .install-title {
    font-size: 24px;
    font-weight: bold;
    color: #000;
    text-align: center;
  }

  .install-header {
    margin-top: 50px;
    display: flex;
    letter-spacing: 3px;
    color: #000;
    margin-bottom: 20px;

    .header-0 {
      color: #e56600;
      font-size: 32px;
    }

    .header-1 {
      font-size: 32px;
      font-weight: bold;
      text-decoration: underline;
    }

    .header-2 {
      letter-spacing: 0;
      margin-left: 10px;
      font-size: 24px;
      font-weight: bold;
    }
  }

  .install-first {
    .title-0 {
      margin-left: 5px;
    }

    .title-1 {
    }

    .title {
      line-height: 30px;
      font-size: 16px;
      font-weight: bold;
      color: #000;
      margin-bottom: 20px;
    }

    .img0, .img1 {
      width: 100%;
      margin-bottom: 20px;

      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }

    .text {
      font-size: 16px;
      color: #555;
      margin-bottom: 10px;
      font-weight: bold;

      .text-span {
        width: 110px;
        line-height: 30px;
        display: inline-block;
      }
    }
  }

  .install-second {
    margin-top: 50px;

    .title {
      font-size: 18px;
      color: #e53333;
      font-weight: bold;
      margin-bottom: 50px;
    }

    .header {
      font-size: 16px;
      color: #e53333;
      font-weight: bold;
      text-align: center;
      margin-bottom: 50px;
    }

    .text {
      p {
        font-size: 14px;
        font-weight: bold;
        color: #555;
        line-height: 30px;
      }
    }
  }
}
</style>